module.exports = __webpack_public_path__ + "static/img/db_kk@2x.c96d3cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/db_kk@2x.png
// module id = kHG6
// module chunks = 2